import * as modelHelper from "./modelHelper";

export const getNewState = (id, object, state) => {
    let newState = {};
    newState[id] = {
        ...state[id],
        ...object
    };

    return {...state, ...newState};
};

export const getNewTabId = (tabList) => {
    let id = 0;
    tabList.forEach((tab) => {
        if (tab.id > id) {
            id = tab.id;
        }
    });

    return id + 1;
};

export const getTabById = (tabList, id) => {
    let tab;
    for (tab of tabList) {
        if (tab.id === id) {
            return tab;
        }
    }
    return null;
};

export const getTabTypeById = (tabList, id) => {
    let tab;
    for (tab of tabList) {
        if (tab.id === id) {
            return tab.type;
        }
    }
    return null;
};

export const getTabByType = (tabList, type) => {
    let tab;
    for (tab of tabList) {
        if (tab.type === type) {
            return tab;
        }
    }

    return null;
};

export const getLastTabByType = (tabList, type) => {
    let lastTab = null;

    let tab;
    for (tab of tabList) {
        if (tab.type === type) {
            lastTab = tab;
        }
    }

    return lastTab;
};

export const getNewModalId = (modalList) => {
    let id = 0;
    modalList.forEach((modal) => {
        if (modal.id > id) {
            id = modal.id;
        }
    });

    return id + 1;
};

export const updateTabSceneById = (tabList, id, scene) => {
    let newTabList = [];

    for (let tab of tabList) {
        if (tab.id === id) {
            newTabList.push(tab.updateScene(scene));
        } else {
            newTabList.push(tab);
        }
    }

    return newTabList;
};

export const updateTabDataById = (tabList, id, name, color, scene) => {
    let newTabList = [];

    for (let tab of tabList) {
        if (tab.id === id) {
            newTabList.push(tab.updateData(name, color, scene));
        } else {
            newTabList.push(tab);
        }
    }

    return newTabList;
};

export const processColorantsForTmc = (formulaColorants) => {
    let colorants = [];

    let colorant;
    for (colorant of formulaColorants) {
        colorants.push({
            name: colorant.name,
            amount: colorant.amount,
            density: colorant.density
        });
    }

    return colorants;
};

export const processList = (list) => {
    if (list === null || !Array.isArray(list)) {
        return [];
    }
    let item;
    let itemList = [];
    for (item of list) {
        itemList.push(item);
    }
    return itemList;
};

export const getDensityByColorantName = (colorantName, colorantList) => {
    let colorant = null;

    for (colorant of colorantList) {
        if (colorantName === colorant.name) {
            return colorant.density;
        }
    }

    return 1;
};

export const updateDatabaseList = (newList) => {
    let databases = [];

    try {
        let newItem;
        for (newItem of newList) {
            databases.push(modelHelper.mapDatabaseToObject(newItem));
        }
    } catch (e) {
        return [];
    }
    return databases;
};

export const mergeLists = (lists) => {
    try {
        let limit = lists.length;

        if (limit === 0) {
            return [];
        }

        if (limit === 1) {
            return lists[0];
        }

        let result = [];
        let intersection = {};

        let item, list;
        for (list of lists) {
            for (item of list) {
                if (intersection[item.id] === undefined) {
                    intersection[item.id] = 0;
                }

                intersection[item.id]++;

                if (intersection[item.id] === limit) {
                    result.push(item);
                }
            }
        }

        return result;
    } catch (e) {
        return [];
    }
};

/**
 * Returns intersection of BIPP by package ID
 * @param   {Array} list
 * @returns {Array}
 */
export const getUniquePackageList = (list) => {
    try {
        const bases = [];
        const bippList = {};

        for (let bipp of list) {
            if (!bases.includes(bipp.base.id)) {
                bases.push(bipp.base.id);
            }

            if (bippList[bipp.package.id] === undefined) {
                bippList[bipp.package.id] = [];
            }

            bippList[bipp.package.id].push(bipp);
        }

        let limit = bases.length;

        if (limit === 0) {
            return [];
        }

        if (limit === 1) {
            return list;
        }

        const result = [];

        for (let bipps of Object.values(bippList)) {
            if (bipps.length === limit) {
                result.push(bipps[0]);
            }
        }

        return result;
    } catch (e) {
        return [];
    }
};

export const mergeEntityLists = (colorList, customColorList) => {
    try {
        const uniqueColorNames = colorList.map((color) => color.displayName);

        return colorList
            .concat(customColorList.filter((color) => !uniqueColorNames.includes(color.displayName)))
            .sort((a, b) => a.displayName.localeCompare(b.displayName));
    } catch (e) {
        return [];
    }
};

export const mergeColorCodeLists = (colorList, customColorList) => {
    try {
        const uniqueColorCodes = colorList.map((color) => color.code);

        return colorList
            .concat(customColorList.filter((color) => !uniqueColorCodes.includes(color.code)))
            .sort((a, b) => a.code.localeCompare(b.code));
    } catch (e) {
        return [];
    }
};
